import React from 'react';
import { Link } from "react-router-dom";
import ProfilForm from "./ProfilForm";
import { updateAccount } from '../../api/api';
import { connect } from 'react-redux';
import { pushToDataLayer } from '../../utils/gtmUtils';

class Profil extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			errorMessage: ''
		}
	}

	onSubmit = (data) => {
		const dataLayer = {
            event: "updateProfile",
            url: window.location.href,
            idPartenaire: this.props.partenaireData.id
        }
        pushToDataLayer(dataLayer);
		updateAccount({ ...data, idBeneficiaire: this.props.beneficiaryData.idBeneficiaire }, this.props.partenaireData.id).then((response) => {
			this.props.history.push('/accueil');
		}).catch((error) => {
			console.log('error', error.response.data);
			this.setState(prevState => ({
				errorMessage: error.response.data
			}));
		})
	}

	goBack = (e) => {
		e.preventDefault();
		this.props.history.push('/accueil');
	}
	render() {
		return (
			<div className="memory-page container main-container _profil profil">
				<ol className="breadcrumb">
					<li className="breadcrumb-item">
						<Link to="/">Accueil</Link>
					</li>
					<li className="breadcrumb-item active" aria-current="page">Mon profil</li>
				</ol>
				<h1 className="text-center">Mon profil</h1>
				<ProfilForm onSubmit={this.onSubmit} beneficiaire={this.props.beneficiaryData} back={this.goBack} />
				<div className="bloc-form_error">
					{this.state.errorMessage &&
						<div className="alert alert-danger" role="alert">
							{this.state.errorMessage}
						</div>
					}
				</div>
			</div>
		);
	};
}

const mapStateToProps = state => ({
	beneficiaryData: state.beneficiaryData.idBeneficiaire ? state.beneficiaryData :  JSON.parse(sessionStorage.getItem('benef')),
	partenaireData: state.partenaireData
})

export default connect(mapStateToProps)(Profil);


// WEBPACK FOOTER //
// ./src/components/ProfilPage/ProfilPage.js